module.exports = __webpack_public_path__ + "static/media/e78b17bb-11fb-4860-8d66-4ee0d0c1e117-greek.dba46e38.woff2";